export const COMPAL_LISTBOX_ID = 'compal-listbox';
export const COMPAL_LISTBOX_ITEM_ID = `${COMPAL_LISTBOX_ID}-item`;
export const COMPAL_LISTBOX_GROUP_ID = `${COMPAL_LISTBOX_ID}-group`;

export const COMMAND_BODY_TEST_ID = 'command-palette.ui.modal.body.command-body-container';
export const COMMAND_CONTAINER_ROW_TEST_ID = 'command-palette.ui.modal.body.command-container-row';
export const SEARCH_INPUT_TEST_ID = 'command-palette.ui.modal.header.search-input';

export const COMPAL_LISTBOX_SCREEN_READER_ID = 'compal-listbox-screen-reader';
